import { Builder } from '@builder.io/react';
import ComparisonChart from './comparisonChart';

Builder.registerComponent(ComparisonChart, {
  name: 'ComparisonChart',
  inputs: [
    {
      name: 'items',
      type: 'list',
      required: true,
      defaultValue: [
        { name: 'Solid Deodorant', price: '$15', isFree: false },
        { name: 'Cream Deodorant', price: '$20', isFree: false },
        { name: '15ct Wipes ($8 value)', price: 'FREE', isFree: true },
        { name: 'Mini Body Wash ($8 value)', price: 'FREE', isFree: true },
        { name: 'EXTRA SAVINGS', price: '$10 OFF', isFree: true },
      ],
      friendlyName: 'Chart Items',
      subFields: [
        {
          name: 'name',
          type: 'string',
          required: true,
          defaultValue: 'Product Name',
          friendlyName: 'Item Name',
        },
        {
          name: 'price',
          type: 'string',
          required: true,
          defaultValue: '$0',
          friendlyName: 'Price/Value',
        },
        {
          name: 'isFree',
          type: 'boolean',
          required: false,
          defaultValue: false,
          friendlyName: 'Special Styling',
        },
      ],
    },
    {
      name: 'totalValue',
      type: 'string',
      required: false,
      defaultValue: 'Total ($51 value)',
      friendlyName: 'Total Value Text',
    },
    {
      name: 'totalPrice',
      type: 'string',
      required: false,
      defaultValue: '$25',
      friendlyName: 'Total Price',
    },
    {
      name: 'savingsText',
      type: 'string',
      required: false,
      defaultValue: 'SAVINGS',
      friendlyName: 'Savings Label',
    },
    {
      name: 'savingsAmount',
      type: 'string',
      required: false,
      defaultValue: '50% OFF',
      friendlyName: 'Savings Amount',
    },
    {
      name: 'showDivider',
      type: 'boolean',
      required: false,
      defaultValue: true,
      friendlyName: 'Show Divider',
    },
    {
      name: 'textColor',
      type: 'color',
      required: false,
      defaultValue: '#2c3e50',
      friendlyName: 'Text Color',
    },
    {
      name: 'freeColor',
      type: 'color',
      required: false,
      defaultValue: '#275681',
      friendlyName: 'Special Items Color',
    },
    {
      name: 'savingsColor',
      type: 'color',
      required: false,
      defaultValue: '#275681',
      friendlyName: 'Savings Color',
    },
  ],
});